import * as React from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/lib/ui/select'
import { useTranslation } from '~/hooks/useTranslation'
import { icons, SERVICE_REQUEST_ICONS } from '../ServiceRequestIcons'
import { TargetIcon } from '../ProfessionalServices/icons'

export default function Filters({ setColumnFilters, select = false }) {
  const selectFilterValues = [
    ['ServiceRequest::OrientationCall', 'orientation'],
    ['ServiceRequest::ResumeReview', 'resume'],
    ['ServiceRequest::LinkedInReview', 'linked_in'],
    ['ServiceRequest::CareerPivotPlanning', 'career_pivot'],
    ['ServiceRequest::ResumeTailoring', 'resume_tailoring'],
    ['ServiceRequest::ResumeWriting', 'resume_writing'],
    ['ServiceRequest::BusinessCardCreation', 'business_card_creation'],
    ['ServiceRequest::GeneralCheckIn', 'general_check_in'],
    ['ServiceRequest::TargetedResearch', 'targeted_research'],
    ['ServiceRequest::SalaryResearch', 'salary_research'],
    ['ServiceRequest::ExecutiveBio', 'executive_bio'],
    ['ServiceRequest::RecruiterGuidanceSupport', 'recruiter_guidance_support'],
    ['ServiceRequest::BoardSearch', 'board_search'],
    ['ServiceRequest::CoverLetterReview', 'cover_letter'],
    ['ServiceRequest::JobSearchStrategy', 'job_search'],
    ['ServiceRequest::NetworkingStrategy', 'networking_strategy'],
    ['ServiceRequest::InterviewPrep', 'interview_prep'],
    ['ServiceRequest::MockInterview', 'mock_interview'],
    ['ServiceRequest::JobSearchBurnout', 'job_search_burnout'],
    ['ServiceRequest::OnboardingSupport', 'onboarding_support'],
    ['ServiceRequest::RetirementSupport', 'retirement_support'],
    ['ServiceRequest::NegotiationStrategy', 'negotiation_strategy'],
  ].sort((a, b) => a[0].localeCompare(b[0]))

  const filterValues = [
    ['ServiceRequest::OrientationCall', 'orientation'],
    ['ServiceRequest::ResumeReview', 'resume'],
    ['ServiceRequest::LinkedInReview', 'linked_in'],
    ['ServiceRequest::CareerPivotPlanning', 'career_pivot'],
    ['ServiceRequest::ResumeTailoring', 'resume_tailoring'],
    ['ServiceRequest::CoverLetterReview', 'cover_letter'],
    ['ServiceRequest::JobSearchStrategy', 'job_search'],
    ['ServiceRequest::TargetCompanyResearch', 'target_company_research'],
    ['ServiceRequest::NetworkingStrategy', 'networking_strategy'],
    ['ServiceRequest::InterviewPrep', 'interview_prep'],
    ['ServiceRequest::MockInterview', 'mock_interview'],
    ['ServiceRequest::JobSearchBurnout', 'job_search_burnout'],
    ['ServiceRequest::OnboardingSupport', 'onboarding_support'],
    ['ServiceRequest::NegotiationStrategy', 'negotiation_strategy'],
  ].sort((a, b) => a[0].localeCompare(b[0]))

  const handleFilterChange = (value) => {
    setColumnFilters([
      {
        id: 'type',
        value: value,
      },
    ])
  }

  const { t } = useTranslation('ServiceTypeCell')

  const filteredFilterValues = select ? selectFilterValues : filterValues

  return (
    <Select defaultValue={null} onValueChange={handleFilterChange}>
      <SelectTrigger
        className="text-lg font-medium md:w-1/3"
        aria-label={t('filter_label')}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={null}>{t('view_all')}</SelectItem>
        {filteredFilterValues.map((filterValue, index) => (
          <SelectItem key={index} value={filterValue[0]}>
            <div className="flex items-center gap-4">
              <FilterIcon value={filterValue[0]} />
              {t(filterValue[1])}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

const FilterIcon = ({ value }) => {
  const iconType = SERVICE_REQUEST_ICONS[value] || 'phone'

  const Icon = icons[iconType]
  if (iconType === 'target') return <TargetIcon strokecolor={'black'} />
  if (!Icon) return null
  return <Icon strokecolor={'currentColor'} className="h-5 w-5 text-black" />
}
